var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "c-slider swiper-container": _vm.shouldSwipe } },
    [
      _vm._t("default", null, {
        nextSlide: _vm.nextSlide,
        prevSlide: _vm.prevSlide,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }